import { Box, type NavTab } from '@csp/csp-web-ui';
import type { FC } from 'react';
import { CspPath } from '../../../CspPath';
import { HeaderNavTabsComponent } from '../component/HeaderNavTabsComponent';
import { useSelectedNavTab } from '../hooks/useSelectedNavTab';
import { useCanListStudyIcfs } from '../../informed-consent/hook/useCanListStudyIcfs';

export const InformedConsentNavSubTabsContainer: FC = () => {
  // content will come as separate pr
  // const informedConsentSubNavigationBlock = StaticContentService.getGenericBlock('webHcpInformedConsentPage', 'tabs');
  const canListStudyIcfs = useCanListStudyIcfs();

  const mainNavTabs: NavTab<CspPath>[] = [
    {
      label: 'Master ICFs', // TODO. set in content CMS when structure is complete informedConsentSubNavigationBlock.button.masterIcfsList
      path: CspPath.INFORMED_CONSENT_LIST_MASTER,
      isEnabledFeature: canListStudyIcfs,
    },
    {
      label: 'Local ICFs', // TODO: set in content CMS when structure is complete informedConsentSubNavigationBlock.button.localIcfsList
      path: CspPath.INFORMED_CONSENT_LIST_LOCAL,
      isEnabledFeature: true,
    },
    {
      label: 'Site ICFs', // TODO: set in content CMS when structure is complete informedConsentSubNavigationBlock.button.siteIcfsList
      path: CspPath.INFORMED_CONSENT_LIST_SITE,
      isEnabledFeature: true,
    },
  ].filter(({ isEnabledFeature }) => isEnabledFeature);

  const selectedTab = useSelectedNavTab(
    mainNavTabs,
    canListStudyIcfs ? CspPath.INFORMED_CONSENT_LIST_MASTER : CspPath.INFORMED_CONSENT_LIST_LOCAL,
  );

  return (
    <>
      <Box height="0.5rem" bgcolor="transparent.grey" />
      <HeaderNavTabsComponent isSubTab tabs={mainNavTabs} selectedPath={selectedTab} />
    </>
  );
};
